import { api } from "./api";


export const companyRegisterApi = (params) => {
    return api.post(`/company/register`, JSON.stringify(params));
};

